module.exports = __webpack_public_path__ + "static/media/Icon_SaveAsDefaults.364ba66c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_SaveAsDefaults.svg
// module id = 2321
// module chunks = 0